export const INT32_MAX = 2147483647;
export const toCurrency = (value, currency = 'USD') => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
    });
    return formatter.format(value);
};
export const toNumberDisplayValue = (value, options) => {
    const { digits, compact } = options ?? {};
    const formatter = new Intl.NumberFormat('en-US', {
        ...(typeof digits === 'number'
            ? {
                notation: compact ? 'compact' : 'standard',
                minimumFractionDigits: digits,
                maximumFractionDigits: digits,
            }
            : { notation: compact ? 'compact' : 'standard' }),
    });
    return formatter.format(value);
};
export const decimalToPercentage = (value, digits = 2) => Number((Math.round((value ?? 0) * 100 * 100) / 100).toFixed(digits));
//# sourceMappingURL=number.js.map